// i18n area 'common' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.de-DE.meta.json.
import type { enUS } from './common'

export const deDE: typeof enUS = {
  nav: {
    home: 'Home',
    vms: 'Virtuelle Maschinen',
    templates: 'Templates',
    importVms: 'VMs importieren',
    containers: 'Container',
    containersApps: 'Apps',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-Images',
    containersOciRegistries: 'OCI-Registries',
    containersCtTemplates: 'CT-Templates',
    networkServices: 'Netzwerkdienste',
    firewall: 'Firewall',
    checkpoints: 'Checkpoints',
    backup: 'Backup',
    monitoring: 'Monitoring',
    cluster: 'Cluster',
    clusterSettings: 'Globale Einstellungen',
    clusterNodes: 'Knoten',
    clusterDevices: 'USB- und PCIe-Ressourcen',
    clusterFederation: 'Föderation',
    network: 'Netzwerk',
    overlayNetworks: 'Overlay-Netzwerke',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Daten',
    storages: 'Storage',
    hci: 'Hyperkonvergenz',
    ceph: 'Ceph',
    system: 'System',
    tasks: 'Tasks',
    events: 'Ereignisse',
    audit: 'Audit',
    diagnostics: 'Diagnose',
    notifications: 'Benachrichtigungen',
    proximity: 'TVirt Proximity',
    users: 'Benutzer und Gruppen',
    groups: 'Gruppen',
    mfa: 'MFA',
    realms: 'Realms und SSO',
    rbac: 'Rollen und Berechtigungen',
    credentials: 'Zugangsdaten',
    scopes: 'Scopes',
    tags: 'Tags',
    explorer: 'Erkunden',
    licensing: 'Lizenz',
    information: 'Informationen'
  },
  mode: {
    light: 'Hell',
    dark: 'Dunkel',
    system: 'System',
    tooltip: 'Theme'
  },
  language: {
    tooltip: 'Sprache'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Nordamerika',
    southAmerica: 'Südamerika',
    asia: 'Asien'
  },
  notFound: {
    title: 'Seite nicht gefunden',
    body: 'Diese Adresse entspricht keiner TVirt-Seite — sie kann sich mit einem Update verschoben haben, oder der Link ist veraltet.',
    backHome: 'Zurück zur Home'
  },
  scopeBrowser: {
    title: 'Scopes',
    all: 'Gesamter Cluster',
    noChildren: 'Keine Unter-Scopes hier',
    recursive: 'Nachkommen einbeziehen',
    collapse: 'Scope-Panel einklappen',
    openPicker: 'Scopes erkunden',
    up: 'Eine Ebene nach oben',
    countTooltip: '{direct} in diesem Scope · {total} mit Nachkommen'
  },
  search: {
    tooltip: 'Suchen (⌘K)',
    placeholder: 'VMs, Netzwerke, Storage suchen…',
    empty: 'Keine Treffer',
    groups: {
      recent: 'Zuletzt verwendet',
      shortcuts: 'Schnellzugriffe',
      actions: 'Aktionen',
      goTo: 'Gehe zu'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Knoten'
    },
    footer: {
      navigate: 'navigieren',
      open: 'öffnen',
      close: 'schließen'
    },
    actions: {
      createVm: 'VM erstellen…',
      uploadIso: 'ISO hochladen…',
      clusterSettings: 'Cluster-Einstellungen',
      consoleOf: 'Zur Konsole von {name}'
    }
  },
  stub: {
    containersSummary: 'Anwendungen und System-Container (CT), mit ihren OCI-Images, Registries und Templates — verwaltet neben Ihren VMs.',
    sectionSummary_vms: 'Virtuelle Maschinen und ihre Templates — Lebenszyklus, Snapshots, Migration und Konsolen.',
    sectionSummary_storages: 'Die Storage-Pools, auf denen Festplatten, Images und Metadaten der VMs leben.',
    sectionSummary_catalogs: 'Das Zuhause der Datei-Artefakte des Clusters: ISO-Images, CT- und VM-Templates und OCI-Archive, organisiert in Katalogen.',
    sectionSummary_overlay: 'VXLAN-Overlay-Netzwerke zwischen den Knoten des Clusters.',
    sectionSummary_fabric: 'Das Inventar des physischen Netzwerks — Switches, Ports, LAGGs und logische Netzwerke.',
    sectionSummary_ipam: 'Die aus Fabric- und Overlay-Netzwerken abgeleitete Adressierung: wer welche Adresse hält.',
    sectionSummary_services: 'DHCP- und DNS-Server, abgeleitet aus dem Netzwerkregister.',
    sectionSummary_ceph: 'Verwaltete Ceph-Cluster auf den TVirt-Knoten.',
    sectionSummary_hci: 'Die hyperkonvergenten Storage-Technologien auf den TVirt-Knoten.',
    sectionSummary_cluster: 'Knoten, Mitgliedschaft und Cluster-Einstellungen.',
    containers: 'Die System-Container stehen auf der Roadmap — diese Sektion wird sie beherbergen.',
    containersApps: 'Containerisierte Anwendungen stehen auf der Roadmap — dieser Bereich wird sie beherbergen.',
    containersPods: 'Pods bündeln Container, die Netzwerk und Volumes teilen — die Instanzen sind die Apps.',
    containersCt: 'System-Container (CT) stehen auf der Roadmap — dieser Bereich wird sie beherbergen.',
    multiscsi: 'TVStor MultiSCSI steht auf der Roadmap — dieser Bereich wird es beherbergen.',
    clusterFederation: 'Die Föderation zwischen TVirt-Clustern steht auf der Roadmap — dieser Bereich wird sie beherbergen.',
    containersOciImages: 'OCI-Images stehen auf der Roadmap — dieser Bereich wird sie beherbergen.',
    containersOciRegistries: 'OCI-Registries stehen auf der Roadmap — dieser Bereich wird sie beherbergen.',
    containersCtTemplates: 'CT-Templates stehen auf der Roadmap — dieser Bereich wird sie beherbergen.',
    importVms: 'Die ESXi- und Proxmox-Importer kommen hierher: Konvertierung der Guests und Massenmigration hinein nach TVirt.',
    backup: 'Das integrierte Backup kommt mit 6.2: deduplizierte content-addressed Repositories, CBT-Inkremente, Unveränderlichkeitsfenster und Repo-to-Repo-Replikation.',
    monitoring: 'Die cluster-wide Dashboards zur Ressourcenkonkurrenz (cpu.ready, PSI-Druck, integrierte Alerts) sind unterwegs — heute leben dieselben Metriken in den Details jeder VM.'
  },
  home: {
    welcome: 'Sie sind angemeldet als: {name}',
    subtitle: 'Ihr TVirt-Cluster auf einen Blick.',
    loadError: 'Die Übersicht konnte nicht geladen werden — ist das TVirt-Backend erreichbar?',
    health: {
      ok: 'Alles in Ordnung',
      warning: 'Achtung',
      critical: 'Kritische Probleme'
    },
    reason: {
      'node-down': '{subject} ist ausgeschaltet',
      'node-stale': '{subject} hat sich eine Weile nicht gemeldet',
      'node-maintenance': '{subject} in Wartung',
      'tasks-failed': {
        one: '{n} fehlgeschlagener Task in den letzten 24h',
        other: '{n} fehlgeschlagene Tasks in den letzten 24h'
      },
      'storage-degraded': 'Storage {subject} degradiert',
      'storage-error': 'Storage {subject} im Fehlerzustand',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'Cluster-Store nicht erreichbar',
      'license-absent': 'keine Lizenz — neue VMs können nicht starten',
      'license-expired': 'Lizenz abgelaufen — neue VMs können nicht starten',
      'license-exceeded': 'Lizenzlimit überschritten — neue VMs können nicht starten',
      'failover-reserve-eroded': 'Failover-Reserve fast aufgebraucht',
      'failover-reserve-exhausted': 'Failover-Reserve erschöpft — neue VMs können nicht starten',

      'oci-cache-nearly-full': 'OCI-Cache auf {subject} fast voll — Digests werden von Hand verdrängt',
      'oci-cache-full': 'OCI-Cache auf {subject} voll — kein Pull gelingt, bis Digests verdrängt werden',
      'config-replica-empty': 'Konfigurations-Replikat auf {subject} ist LEER — der Knoten hat keine Cluster-Konfiguration, bis eine Replikation gelingt',
      'config-replica-stalled': 'Konfigurations-Replikation auf {subject} steht still — die lokale Kopie hängt der Cluster-Konfiguration hinterher'
    },
    staleChip: 'Daten nicht aktuell',
    staleAsOf: 'letzte Replikation {time}',
    zone: {
      nodes: 'Knoten',
      failoverReserve: 'Failover-Reserve',
      capacity: 'Kapazität',
      workload: 'Arbeitslast',
      protection: 'Schutz',
      activity: 'Letzte Aktivität'
    },
    reserve: {
      state: {
        ok: 'Reserve intakt',
        eroded: 'Reserve fast aufgebraucht',
        exhausted: 'Reserve erschöpft',
        unknown: 'Reserve unbekannt'
      },
      tolerate: {
        one: 'toleriert den Verlust von {n} Knoten',
        other: 'toleriert den Verlust von {n} Knoten'
      },
      usedOf: '{used} / {allowed} GiB belegt',
      keepFree: '{n} GiB für den Failover freigehalten',
      expendable: 'davon {n} im Betrieb opferbar',
      headroom: 'es lassen sich noch {n} GiB starten',
      short: 'der Reserve fehlen {n} GiB — neue VMs können nicht starten',
      hp: {
        usedOf: 'Seiten zu {size} — in Benutzung: {used} / {allowed}',
        keepFree: 'für den Failover freigehalten: {keep}',
        headroom: 'noch startbar: {n}',
        short: 'in der Reserve fehlend: {n} — neue VMs mit Riesenseiten können nicht starten'
      },
      worstCase: 'schlimmster Fall: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Noch kein Knoten hat seinen Speicher gemeldet — die Reserve lässt sich nicht berechnen, und kein Start wird abgelehnt.',
      reason: {
        attestedDown: 'als ausgeschaltet attestiert',
        maintenance: 'in Wartung',
        unreachable: 'nicht erreichbar',
        capacityUnknown: 'Speicher nicht gemeldet'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} Cores / {threads} Threads',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktive VM',
        other: '{n} aktive VMs'
      },
      activeVmsUnknown: 'aktive VMs unbekannt',
      lastSeen: 'gesehen {time}',
      neverSeen: 'nie gesehen',
      down: 'Ausgeschaltet',
      maintenance: 'Wartung',
      stale: 'Nicht erreichbar'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisioniert',
      reserve: 'Reserve {n} GiB',
      unobserved: 'Kapazität noch nicht beobachtet',
      empty: 'Noch kein Storage'
    },
    workload: {
      vms: 'Virtuelle Maschinen',
      apps: 'Apps',
      services: 'Netzwerkdienste',
      empty: 'Noch keine',
      phasesUnknown: 'Aufteilung nach Phase nicht verfügbar'
    },
    protection: {
      none: 'Kein Backup-Ziel konfiguriert — schützen Sie Ihre Konfiguration.',
      configure: 'Checkpoints konfigurieren',
      noRuns: 'Noch kein Checkpoint erstellt.',
      last: 'Letzter Checkpoint',
      onTarget: 'auf {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Keine aktuelle Aktivität',
      failed24: {
        one: '{n} fehlgeschlagen in 24h',
        other: '{n} fehlgeschlagen in 24h'
      },
      viewAll: 'Alle Tasks anzeigen'
    }
  },
  notes: {
    title: 'Notizen',
    tabEdit: 'Bearbeiten',
    tabPreview: 'Vorschau',
    placeholder: 'Freie Notizen des Operators — Markdown wird in der Vorschau gerendert',
    empty: 'Keine Notizen',
    tooLarge: 'Die Notizen überschreiten das Limit von 64 KiB',
    saveError: 'Die Notizen konnten nicht gespeichert werden'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Die Antwort des Backends enthält einen Wert, den diese Oberfläche nicht kennt: {field}={value} — aktualisiere die Weboberfläche auf die Backend-Version.',
    contractErrorItems: '{count} Objekte dieser Liste kann diese Oberfläche nicht lesen ({field}={value}); sie werden nicht angezeigt.',
    staleHint: 'Der Store ist nicht erreichbar — dies ist die Config-Replik dieses Knotens; der Zustand der Flotte ist unbekannt.',
    staleStateAge: 'Zustand von {time}',
    staleStateNever: 'Zustand nie vom Store empfangen: Sie sehen nur die eigenen Beobachtungen dieses Knotens',
    staleStateTooltip: 'Der Cluster-Store ist nicht erreichbar: der beobachtete Zustand (Phase, Knoten, Agent) stammt aus der Zustandsreplik dieses Knotens und entspricht dem letzten erfolgreichen Lesen aus dem Store — er kann veraltet sein.',
    noPermission: 'Sie haben keine Berechtigung für diese Aktion',
    actionStillRunning: 'Die Aktion läuft noch — das Ergebnis ist noch nicht bekannt',
    staleWrite: 'Jemand anderes hat dieses Objekt geändert, während Sie es bearbeitet haben — es wurde nichts geschrieben. Laden Sie neu und wiederholen Sie Ihre Änderung auf dem aktuellen Stand.',
    staleReload: 'Neu laden',
    preview: 'Vorschau',
    previewTitle: 'Vorschau des Ergebnisses',
    previewNothingWritten: 'Auf dem Server simuliert — es wurde nichts geschrieben.',
    previewChanged: 'Hervorgehoben: die Werte, die sich ändern würden.'
  },
  context: {
    copySelection: 'Markierten Text kopieren'
  },
  crud: {
    create: 'Erstellen',
    viewDetails: 'Details anzeigen',
    viewOrEdit: 'Anzeigen oder bearbeiten',
    selected: 'ausgewählt',
    viewUsingVms: 'VMs anzeigen, die diese Ressource verwenden',
    clearSelection: 'Auswahl aufheben',
    deleteSelected: 'Ausgewählte löschen',
    bulkConfirmBody: {
      one: '{count} ausgewähltes Element löschen? Falls geschützt, wird es gemeldet und behalten.',
      other: 'Die {count} ausgewählten Elemente löschen? Geschützte werden gemeldet und behalten.'
    },
    bulkDeleted: 'gelöscht',
    bulkRefused: 'abgelehnt',
    fieldId: 'ID',
    createdAt: 'Erstellt am',
    updatedAt: 'Aktualisiert am',
    immutableField: 'Bei der Erstellung fixiert — der Contract erlaubt keine Änderung',
    immutableScope: 'Der Scope wird bei der Erstellung zugewiesen; manche Ressourcen ziehen mit einer eigenen Aktion um',
    observedField: 'Beobachteter Zustand — von der Plattform gemeldet, nicht bearbeitbar'
  }
}
